import * as React from 'react'

const SvgLockedFilledIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.25 8.5H14V4.75a3.75 3.75 0 10-7.5 0V8.5H5.25C4.56 8.5 4 9.06 4 9.75v7.5c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-7.5c0-.69-.56-1.25-1.25-1.25zm-7.5-3.75a2.5 2.5 0 015 0V8.5h-5V4.75z"
      fill="#163250"
    />
  </svg>
)

export default SvgLockedFilledIcon
